export const likeOrUnlikeStoreStateChanger = (state, action) => {
  return {
    ...state,
    data: state.data.map(feed => {
      if (feed.feedId === action.feedId) {
        feed.likes = feed.liked ? feed.likes - 1 : feed.likes + 1;
        feed.liked = !feed.liked;
      }
      return feed;
    })
  };
};

export const likeOrUnlikeCommentStoreStateChanger = (state, action) => {
  return state.commentData.data[action.feedId] = state.commentData.data[action.feedId].map(comment => {
    if (comment.feedId === action.feedId && comment.commentId === action.commentId) {
      comment.likes = comment.likedByMe ? comment.likes - 1 : comment.likes + 1;
      comment.likedByMe = !comment.likedByMe;
      return comment;
    } else {
      return comment;
    }
  });
};

export const followTribunUserStateChanger = (state, action) => {
  return {
    ...state,
    data: state.data.map(feed => {
      if (feed.userId === action.userId) {
        feed.user.stats.followers = action.payload.followerCount;
        feed.user.following = !feed.user.following;
      }
      return feed;
    })
  };
};

export const sendCommentStoreStateChanger = (state, action) => {
  return {
    ...state,
    data: state.data.map(feed => {
      if (feed.feedId === action.feedId) {
        feed.comments += 1;
      }
      return feed;
    })
  };
};

export const deleteCommentStoreStateChanger = (state, action) => {
  return {
    ...state,
    data: state.data.map(feed => {
      if (feed.feedId === action.feedId) {
        feed.comments -= 1;
      }
      return feed;
    })
  };
};

export const commentForbiddenStoreStateChanger = (state, action) => {
  return {
    ...state,
    data: state.data.map(feed => {
      if (feed.feedId === action.feedId) {
        feed.commentForbidden = !feed.commentForbidden;
      }
      return feed;
    })
  };
};

export const shareOrHideStoreStateChanger = (state, action) => {
  return {
    ...state,
    data: state.data.map(feed => {
      if (feed.feedId === action.feedId) {
        feed.hidden = !feed.hidden;
      }
      return feed;
    })
  };
};

export const updateTribunCouponNameStoreStateChanger = (state, action) => {
  if (state.data) {
    return {
      ...state,
      data: state.data.map(feed => {
        if (feed.feedId === action.feedId) {
          feed.description = action.description;
        }
        return feed;
      })
    };
  }
};

export const deleteTribunCouponNameStoreStateChanger = (state, action) => {
  if (state.data) {
    return {
      ...state,
      data: state.data.map(feed => {
        if (feed.feedId === action.feedId) {
          feed.description = null;
        }
        return feed;
      })
    };
  }
};
